<template>
  <div class="signIn-comp-canvas">
    <!-- 七天列表 -->
    <div class="signIn-days-canvas">
      <div class="signIn-day" v-for="(item, index) in signInData" :key="index">
        <!-- 非当天信息 -->
        <div class="not-current-day" v-if="!item.isCurDay">
          <!-- 天数 -->
          <div class="name">{{item.name}}</div>
          <!-- 礼物状态图片 -->
          <div class="gift-canvas" :class="['gift-status-'+item.prizeStatus]"></div>
          <!-- 按钮 / 信息  -->
          <div v-if="item.prizeStatus == 2" class="not-curday-receive-btn"></div>
          <div v-if="item.prizeStatus == 4 || item.prizeStatus == 3" class="not-curday-info-canvas">
            <div class="info-money" :class="{'miss-lab' : item.prizeStatus == 3}">
              <span v-show="item.money >= 0">¥{{item.money}} 现金</span>
            </div>
            <div class="info-score" :class="{'miss-lab' : item.prizeStatus == 3}">
              <span v-show="item.score >= 0">{{item.score}} 积分</span>
            </div>
          </div>
          <!-- 漏签样式 -->
          <div v-if="item.prizeStatus == 3" class="miss-sign-canvas">
            <div class="miss-img"></div>
          </div>
        </div>

        <!-- 当天信息 -->
        <div class="current-day" v-if="item.isCurDay">
          <!-- 礼物状态图片 -->
          <div
            class="gift-canvas"
            :class="['gift-status-'+(item.prizeStatus == 0 ? curstatus ? 0 : 3 : item.prizeStatus)]"
          ></div>
          <!-- 现金&积分信息 -->
          <div class="curday-info-canvas">
            <div class="info-money">
              <span v-show="item.money >= 0">¥{{item.money}} 现金</span>
            </div>
            <div class="info-score">
              <span v-show="item.score >= 0">{{item.score}} 积分</span>
            </div>
          </div>
          <!-- 按钮 -->
          <div
            v-if="item.prizeStatus == 0"
            class="cur-not-receive-btn"
            :class="{'cur-btn-disable': !curstatus}"
            @click="receivePrizeHandler(item)"
          ></div>
          <div v-if="item.prizeStatus == 1" class="cur-recevie-btn"></div>
        </div>
      </div>
    </div>

    <!-- 更多 -->
    <div class="more-canvas"></div>

    <!-- 兑换确认框 -->
    <el-dialog title="提示" :visible.sync="tipVisible" :show-close="true">
      <div class="tips-icon"></div>
      <div class="tip-lab">
        <div>你当前的会员等级{{userLevel}}无法参与此活动</div>
        <div>请提升至{{joinLevel}}等级后再尝试</div>
      </div>
      <div class="return-home" @click="returnHomeHandler()">返回首页</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "signIn-comp",
  props: {
    signInData: Array,
    levelTipVisible: Boolean,
    userLevel: Number,
    joinLevel: Number,
    curstatus: Boolean
  },
  data() {
    return {
      // isCurDay：是否为当日奖励
      // prizeStatus：0 待领取，1 已领取（当日），2 不可领取， 3 已领取（非当日）
      // 0=当天未领取 1=当天已经领取  2=今天之前已领取 3=今天之前未领取  4=今天之后未领取
      tipVisible: false
    };
  },
  methods: {
    // 领取奖励操作
    receivePrizeHandler(item) {
      if (this.levelTipVisible) {
        this.tipVisible = true;
        return;
      }

      if (!this.curstatus) {
        this.$message({
          message: "签到要求未完成，无法领取",
          type: "warning",
          center: true
        });
        return;
      }

      let gift = {
        m: item.money,
        s: item.score,
        status: item.prizeStatus
      };
      this.$emit("compGetPrize", gift);
    },
    //返回首页
    returnHomeHandler() {
      this.tipVisible = false;
      this.$emit("backHome");
    }
  }
};
</script>

<style lang="scss">
.signIn-comp-canvas {
  width: 100%;
  height: 100%;
  padding: 0 16px;

  .signIn-day {
    float: left;
    width: 160px;
    height: 360px;

    // 非当日
    .not-current-day {
      position: relative;
      width: 144px;
      height: 334px;
      margin: 0 auto;
      background: url("./img/not-curday-bg.png") no-repeat center center;

      .name {
        float: left;
        width: 100%;
        text-align: center;
        height: 25px;
        font-family: "MicrosoftYaHei";
        font-size: 18px;
        font-weight: bold;
        color: #b8b5da;
        margin-top: 65px;
      }

      .gift-canvas {
        float: left;
        width: 120px;
        height: 100px;
        margin-top: 30px;
        margin-left: 11px;
      }

      .not-curday-receive-btn {
        float: left;
        margin-left: 17px;
        margin-top: 28px;
        width: 110px;
        height: 32px;
        background: url("./img/not-curday-receive.png") no-repeat center center;
      }

      .not-curday-info-canvas {
        float: left;
        width: 100%;
        height: 50px;
        margin-top: 5px;

        .info-money,
        .info-score {
          width: 100%;
          height: 25px;
          line-height: 25px;
          text-align: center;
          font-family: "MicrosoftYaHei";
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;
        }

        .miss-lab {
          opacity: 0.3;
        }
      }

      .miss-sign-canvas {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: rgba(0, 0, 0, 0);

        .miss-img {
          position: absolute;
          width: 100px;
          height: 100px;
          left: 22px;
          top: 158px;
          background: url("./img/miss-img.png") no-repeat center center;
        }
      }
    }

    // 当日
    .current-day {
      width: 178px;
      height: 390px;
      margin-left: -9px;
      background: url("./img/curday-bg.png") no-repeat center center;

      .gift-canvas {
        float: left;
        width: 120px;
        height: 100px;
        margin-top: 120px;
        margin-left: 29px;
      }

      .curday-info-canvas {
        float: left;
        width: 100%;
        height: 50px;
        margin-top: 5px;

        .info-money,
        .info-score {
          width: 100%;
          height: 25px;
          line-height: 25px;
          text-align: center;
          font-family: "MicrosoftYaHei";
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;
        }
      }

      .cur-not-receive-btn {
        float: left;
        width: 134px;
        height: 36px;
        background: url("./img/cur-not-receive-btn.png") -0px -10px;
        margin-left: 22px;
        margin-top: 13px;
        cursor: pointer;
      }

      .cur-not-receive-btn:hover {
        background: url("./img/cur-not-receive-btn.png") -0px -66px;
      }

      .cur-recevie-btn {
        float: left;
        width: 110px;
        height: 32px;
        background: url("./img/cur-receive-btn.png") no-repeat center center;
        margin-left: 34px;
        margin-top: 15px;
      }

      .cur-btn-disable,
      .cur-btn-disable:hover {
        background: url("./img/receive-btn-disable.png") no-repeat center center;
        background-size: contain;
      }
    }

    .gift-status-0 {
      background: url("./img/gift-status-0.png") no-repeat center center;
    }
    .gift-status-1 {
      background: url("./img/gift-status-1.png") no-repeat center center;
    }
    .gift-status-4,
    .gift-status-3 {
      background: url("./img/gift-status-2.png") no-repeat center center;
    }
    .gift-status-2 {
      background: url("./img/gift-status-3.png") no-repeat center center;
    }
  }

  // 更多
  .more-canvas {
    position: absolute;
    top: 390px;
    left: 50%;
    margin-left: -213px;
    width: 427px;
    height: 36px;
    background: url("./img/more.png") no-repeat center center;
  }

  // 弹窗信息样式
  .el-dialog__wrapper {
    z-index: 4000 !important;
    background: rgba(0, 0, 0, 0.6);
  }
  .el-dialog {
    width: 380px !important;
    height: 292px;
    background-color: #fff;
    border-radius: 10px;
    margin-top: -146px !important;
    top: 50%;

    .el-dialog__header {
      text-align: center;

      .el-dialog__close {
        background: url("./img/icon-close.png") no-repeat center center;
        width: 16px;
        height: 16px;
      }

      .el-icon-close:before {
        content: " ";
      }
    }

    .el-dialog__title {
      text-align: center;
      font-family: "MicrosoftYaHei";
      font-size: 14px;
      color: #150036;
      font-weight: normal;
    }

    .el-dialog__body {
      padding: 0px;

      .tips-icon {
        width: 53px;
        height: 54px;
        margin: 25px auto 0px auto;
        background: url("./img/tips-icon.png") no-repeat center center;
      }

      .tip-lab {
        width: 100%;
        height: 40px;
        line-height: 20px;
        text-align: center;
        margin-top: 25px;
        font-family: "MicrosoftYaHei";
        font-size: 14px;
        font-weight: bold;
        color: #150036;
      }

      .return-home {
        width: 158px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: #2b2b2b;
        background: #fff;
        border-radius: 4px;
        border: solid 1px #2b2b2b;
        margin: 25px auto 0px auto;
        cursor: pointer;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/build08/components/signInActivity/components/signIn/signIn-comp.vue